import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import {
  SENSOR_DATA_SOURCE_TYPE,
  SENSOR_DATA_DEFAULT_CONTEXT,
  SOURCE_TYPE_OPTIONS,
  DISPLAY_OPTIONS,
} from './sensorDataWidgetTypes';
import {
  selectAllMetricsGroups,
} from '../../../../redux/slices/metricsGroupSlice/metricsGroupSlice';

const SensorDataWidgetEdit = ({ context, onChange }) => {
  const {
    sourceType = SENSOR_DATA_DEFAULT_CONTEXT.sourceType,
    metricGroupId = null,
    displayType = SENSOR_DATA_DEFAULT_CONTEXT.displayType,
  } = context;

  const metricGroups = useSelector(selectAllMetricsGroups) || [];
  const selectedMetricGroupId = metricGroupId != null ? String(metricGroupId) : '';

  useEffect(() => {
    if (!context.sourceType || !context.displayType) {
      onChange({
        ...SENSOR_DATA_DEFAULT_CONTEXT,
        ...context,
        sourceType: context.sourceType || SENSOR_DATA_DEFAULT_CONTEXT.sourceType,
        displayType: context.displayType || SENSOR_DATA_DEFAULT_CONTEXT.displayType,
      });
    }
  }, []);

  const handleSourceTypeChange = (e) => {
    const next = e.target.value;
    onChange({
      ...context,
      sourceType: next,
      metricGroupId: next === SENSOR_DATA_SOURCE_TYPE.METRIC_GROUP ? metricGroupId : null,
    });
  };

  const handleMetricGroupChange = (e) => {
    const { value } = e.target;
    onChange({
      ...context,
      metricGroupId: value ? Number(value) : null,
    });
  };

  const handleDisplayTypeChange = (e) => {
    onChange({ ...context, displayType: e.target.value });
  };

  return (
    <>
      <Form.Group>
        <Form.Label column>Data Source</Form.Label>
        <Form.Control as="select" value={sourceType} onChange={handleSourceTypeChange}>
          {SOURCE_TYPE_OPTIONS.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </Form.Control>
      </Form.Group>

      {sourceType === SENSOR_DATA_SOURCE_TYPE.METRIC_GROUP && (
        <Form.Group>
          <Form.Label column>Data Group</Form.Label>
          {metricGroups.length === 0 ? (
            <div className="text-muted small">No data groups available.</div>
          ) : (
            <Form.Control
              as="select"
              value={selectedMetricGroupId}
              onChange={handleMetricGroupChange}
            >
              <option disabled value="">Select a data group...</option>
              {metricGroups.map((g) => (
                <option key={g.id} value={g.id}>{g.name}</option>
              ))}
            </Form.Control>
          )}
          {metricGroups.length > 0 && !selectedMetricGroupId && (
            <Form.Text className="text-danger">
              Select a data group.
            </Form.Text>
          )}
        </Form.Group>
      )}

      <Form.Group>
        <Form.Label column>Display</Form.Label>
        <Form.Control as="select" value={displayType} onChange={handleDisplayTypeChange}>
          {DISPLAY_OPTIONS.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </Form.Control>
      </Form.Group>
    </>
  );
};

SensorDataWidgetEdit.propTypes = {
  context: PropTypes.shape({
    sourceType: PropTypes.string,
    metricGroupId: PropTypes.number,
    displayType: PropTypes.string,
    timeRange: PropTypes.string,
  }),
  onChange: PropTypes.func,
};

SensorDataWidgetEdit.defaultProps = {
  context: {},
  onChange: () => {},
};

export default SensorDataWidgetEdit;
